import { defineComponent as _defineComponent } from 'vue'
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";
import SvgCreate from "@/assets/icons/magic-wand.svg";
import { useWindowResize } from "@/utils/useWindowSize";
import { computed } from "vue";

interface Props {
    isOnlyIcon?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateButton',
  props: {
    isOnlyIcon: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
    isOnlyIcon?: boolean
}




const { width } = useWindowResize();
const getVariant = computed(() => {
    if (props.isOnlyIcon) {
        return 'iconOnly';
    }
    return width.value <= 768 ? 'iconOnly' : 'withIcon';
});


return { __sfc: true,props, emits, width, getVariant, BaseButtonV2, SvgCreate }
}

})